import { type ReactNode } from 'react';

import { Layout } from '../../components/Layout';
import { ContentContainer } from '../ContentContainer';
import { FiltersContainer } from '../FiltersContainer';
import { FooterContainer } from '../FooterContainer';
import { SaveSearchModalProvider } from '../SaveSearchModalProvider';
import { ToTopButtonContainer } from '../ToTopButtonContainer';

export function PageContainer(): ReactNode {
  return (
    <Layout
      content={<ContentContainer />}
      filters={
        <SaveSearchModalProvider>
          <FiltersContainer />
        </SaveSearchModalProvider>
      }
      footer={<FooterContainer />}
      toTopButton={<ToTopButtonContainer />}
    />
  );
}
